import React from "react";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import { latestNews } from "../../fifthUtils/constant";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LatestNews = (props) => {
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const history = useHistory()
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <div className="fifth-des-latest-news-main">
            <HeaderComponent title={selectedLanguage?.txt_latest_news} lineClass='bg-White' titleClass='color-white' />
            <div className="fifth-des-latest-news">
                {latestNews?.slice(0, 3)?.map((v, i) => {
                    if (Array.isArray(v?.img)) {
                        return (
                            <div key={i}>
                                <Slider {...settings} className="fifth-des-dots">
                                    {v?.img?.map((image, index) => (
                                        <div key={index} className="fifth-des-latest-news-slider-div">
                                            <img src={image} alt="" />
                                        </div>
                                    ))}
                                </Slider>
                                <div className="fifth-des-latest-news-text-div">
                                    <h2>
                                        {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div key={i}>
                                <div className="fifth-des-latest-news-img-div">
                                    <img src={v?.img} alt="" />
                                    <div className="fifth-des-latest-news-img-overlap">
                                        <h3>
                                            {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                        </h3>
                                        <p>{selectedLanguage?.txt_latest_news}, {selectedLanguage?.txt_news}</p>
                                    </div>
                                </div>
                                <div className="fifth-des-latest-news-text-div">
                                    <h2>
                                        {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
            <div className="fifth-des-more-btn-div">
                <button onClick={() => history?.push(allPaths?.FIFHTLATESTNEWS)} className="fifth-des-more-btn">
                    {selectedLanguage?.txt_more}
                </button>
            </div>
        </div>
    )
}
export default LatestNews